<template>
  <CustomModal
    :value="show"
    :title="title"
    save-text="Confirmar"
    cancel-text="Cancelar"
    @cancel="cancel"
    @save="save"
  >
    <ValidationObserver
      ref="formModalObserver"
      tag="form"
      novalidate
      @submit.prevent="save"
    >
      <div class="row">
        <div class="col-12">
          <p>
            Esta acción notificará a Rehabilitación Vocacional (ARV) que el
            referido queda cancelado. Esta acción no se puede deshacer.
          </p>
        </div>
        <div class="col-12">
          <ValidationProvider
            v-slot="{ errors }"
            mode="eager"
            rules="required|max:500"
          >
            <div class="form-group">
              <label>Motivo de la cancelación *</label>
              <textarea
                v-model="comment"
                class="form-control"
                rows="4"
                maxlength="500"
                :class="{ 'is-invalid': errors[0] }"
              ></textarea>
              <div v-if="errors[0]" class="invalid-feedback">
                {{ errors[0] }}
              </div>
              <small
                class="form-text text-right"
                :class="{ 'text-danger': comment.length >= 450 }"
              >
                {{ comment.length }} / 500
              </small>
            </div>
          </ValidationProvider>
        </div>
      </div>
    </ValidationObserver>
  </CustomModal>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import CustomModal from '@/components/common/CustomModal';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'CancelReferralModal',
  mixins: [alert],
  components: {
    CustomModal,
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    show: false,
    title: '¿Confirma cancelar este referido?',
    comment: '',
  }),
  methods: {
    open() {
      this.comment = '';
      this.show = true;
    },
    async cancel() {
      await this.$refs.formModalObserver.reset();
      this.comment = '';
      this.show = false;
      this.$emit('cancel');
    },
    async save() {
      const isValid = await this.$refs.formModalObserver.validate();

      if (!isValid) {
        this.ShowToast(
          'Atención',
          'Por favor, indique el motivo de la cancelación.',
          'error'
        );
        return;
      }

      this.show = false;
      this.$emit('save', { comment: this.comment });
      this.comment = '';
    },
  },
};
</script>
